import React from "react";

const PageContext = React.createContext<
  [string | null, ((title: string | null) => void) | null]
>([null, null]);

export default PageContext;
